var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/phone_number/index.js
 ** module id = 782
 ** module chunks = 0
 **/